import { cn } from 'utils/cn';

export const Cell = ({
  children,
  className,
  isPDF,
  pdfWidth,
  defaultWidth,
}: {
  children: React.ReactNode;
  className?: string;
  isPDF?: boolean;
  pdfWidth?: string;
  defaultWidth?: string;
}) => (
  <div
    className={cn('text-center px-0.5', className, {
      [`${pdfWidth} flex items-center justify-center`]: isPDF,
      [defaultWidth || '']: !isPDF,
    })}
  >
    {children}
  </div>
);
